import teachingCalendar from '@/api/teaching-calendar'
import { baseState, baseMutations } from '@/store/mixins'
import year from '@/api/academic-year'
import term from '@/api/term-semester'
import TeacherProfile from '@/api/teacher-profile'
import moment from 'moment'

export const state = {
	...baseState,
	date_from: moment()
		.add(-1, 'Month')
		.format('DD-MM-YYYY'),
	date_to: moment()
		.format('DD-MM-YYYY'),
	ac_status_id: 1,
	ac_year_id: undefined,
	ac_term_id: undefined,
}

export const getters = {
	tConvert: () => time => {
		if (time === null || time === undefined) return null
		// Check correct time format and split into components
		time = time
			.toString()
			.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]

		if (time.length > 1) {
			// If time format correct
			time = time.slice(1) // Remove full string match value
			time[5] = +time[0] < 12 ? ' AM' : ' PM' // Set AM/PM
			time[0] = +time[0] % 12 || 12 // Adjust hours
		}
		return time.join('') // return adjusted time or original string
	}
}

export const mutations = {
	...baseMutations,
	SET_DATE_FROM(state, data) {
		state.date_from = data
	},
	SET_DATE_TO(state, data) {
		state.date_to = data
	},
	SET_AC_STATUS(state, acStatusId) {
		state.ac_status_id = acStatusId
	},
	SET_YEAR_ID(state, data) {
		state.ac_year_id = data
	},
	SET_TERM_ID(state, data) {
		state.ac_term_id = data
	}
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				search: context.state.search,
				ac_year_id: context.state.ac_year_id,
				ac_term_id: context.state.ac_term_id,
				date_range: [context.state.date_from, context.state.date_to]
			},
			attrubutes
		)
		return teachingCalendar.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	update(context, data) {
		return teachingCalendar.update(data)
	},
	getYear(context, attributes = {}) {
		return year.get({
			params: Object.assign(
				{
					fields: {
						academic_years: 'ac_year_id,ac_year,ac_status_id'
					},
					filter: {
						ac_status_id: context.state.ac_status_id
					},
					page: -1
				},
				attributes
			),
			headers: {
				'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
			}
		})
	},
	getTerm(context, attributes = {}) {
		return term.get({
			params: Object.assign(
				{
					fields: {
						academic_terms: 'ac_term_id,term_name,ac_status_id'
					},
					filter: {
						ac_status_id: context.state.ac_status_id
					},
					page: -1
				},
				attributes
			),
			headers: {
				'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
			}
		})
	},
	getTeacher(context, attributes = {}) {
		return TeacherProfile.get({
			headers: {
				'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
			},
			params: {
				page: -1,
				fields: {
					setup_teacher_profiles: 'teacher_id,fname_foreign,lname_foreign'
				},
				...attributes
			}
		})
	},
	getStaff(context, data) {
		return teachingCalendar.staff(data)
	}
}
